const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://rasatva.parasmesoft.in/omens/api";
const IMG_BASE_URL = process.env.REACT_APP_IMG_BASE_URL || "https://rasatva.parasmesoft.in/omens/";
const THIRD_PARTY_API_BASE_URL = process.env.REACT_APP_THIRD_PARTY_API_BASE_URL || "https://json.astrologyapi.com/v1";
const THIRD_PARTY_API_KEY = process.env.REACT_APP_THIRD_PARTY_API_KEY || "ByVOIaODH57QRVi6CqswHXGlcpDvj7tZBRoorY";
const THIRD_PARTY_USER_ID = process.env.REACT_APP_THIRD_PARTY_USER_ID || "4545";
const THIRD_PARTY_X_TOKEN = process.env.REACT_APP_THIRD_PARTY_X_TOKEN || "ak-1ad22ee40662b0cec0d4e8a61de11da29b8e7143";
const AGORA_APP_ID = process.env.REACT_APP_AGORA_APP_ID || 'a0d5f8d66e014624ad5d695deb8fb69c';
const AGORA_APP_CHAT_APP_KEY = process.env.REACT_APP_AGORA_APP_CHAT_APP_KEY || "411270396#1464658";
const THIRD_PARTY_PDF_BASE_URL = process.env.REACT_APP_THIRD_PARTY_PDF_BASE_URL || "https://pdf.astrologyapi.com/v1";
const WEB_DOMAIN_KEY = process.env.REACT_APP_WEB_DOMAIN_KEY || "https://rasatva.parasmesoft.in/"
const ASTRO_USER_ID = process.env.REACT_APP_ASTRO_USER_ID || "653674";
const ASTRO_API_KEY = process.env.REACT_APP_ASTRO_API_KEY || "ak-1ad22ee40662b0cec0d4e8a61de11da29b8e7143";

export {
    API_BASE_URL,
    IMG_BASE_URL,
    THIRD_PARTY_API_BASE_URL,
    THIRD_PARTY_PDF_BASE_URL,
    THIRD_PARTY_USER_ID,
    THIRD_PARTY_API_KEY,
    THIRD_PARTY_X_TOKEN,
    AGORA_APP_ID,
    AGORA_APP_CHAT_APP_KEY,
    WEB_DOMAIN_KEY,
    ASTRO_USER_ID,
    ASTRO_API_KEY
}